import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import CustomerServiceIcon from '@icons/CustomerServiceIcon';
import { InquiryCommentRow } from '@models/inquiry';
import dayjs from 'dayjs';

interface Props {
    comment: InquiryCommentRow;
}

function InquiryComment({ comment }:Props) {
    const {
        content, authorType, createdAt, fileUrls,
    } = comment;
    const isCounselor = authorType !== 'CUSTOMER';
    return (
        <Container fullWidth spacing={4} data-counselor={isCounselor}>
            <Row spacing={2}>
                {isCounselor && (
                    <CounselorAvatar>
                        <CustomerServiceIcon size={24} color='var(--color-icon-unselected)'/>
                    </CounselorAvatar>
                )}
                <Text color={colors.textSecondary}>
                    {dayjs(createdAt).format('YYYY.MM.DD HH:mm')}
                </Text>
            </Row>
            <Content color={colors.textPrimary}
                dangerouslySetInnerHTML={{ __html: content }}
                as='div' />
            {(fileUrls && fileUrls.length !== 0) && (
                <Images>
                    {fileUrls.map((fileUrl) => (
                        <Image src={fileUrl}
                            key={fileUrl}/>
                    ))}
                </Images>
            )}
        </Container>
    );
}

const Container = styled(Column)`
    background-color: var(--color-background-pure);
    padding: var(--spacing-4);

    &[data-counselor="true"] {
        background-color: var(--color-background-base);
    }
`;

const CounselorAvatar = styled.div`
    background-color: var(--color-background-pure);
    border: 1px solid var(--color-border-default);
    border-radius: var(--radius-full);
    display: flex;
    padding: var(--spacing-2);
`;

const Content = styled(Text)`
    white-space: pre-wrap;
    word-break: break-word;
    width: 100%;

    img {
        max-width: 100%;
    }
`;

const Images = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-3);
    width: 100%;

    img {
        width: 100%;
    }
`;

export default InquiryComment;
